import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  Badge,
  Row,
  Col,
  ProgressBar,
  Form,
  Image,
  Button,
  Spinner,
} from "react-bootstrap";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import IMAGES from "../constants/images";
import { Icon } from "@iconify/react";
import {
  addCommentReview,
  addDisputeCommentReview,
  fetchProductReviews,
  getReviewAllReply,
} from "api/ReviewService";
import moment from "moment";
import { reviewPopularMentions } from "api/ProductService";
import { highlightTagInText } from "utils/helpers";
import useDebounce from "hooks/useDebounce";
import { useAuth } from "context/UserContext";
import CommonModal from "./CommonModal";
import TextInput from "./TextInput";
import { toast } from "react-toastify";
import ReactShowMoreText from "react-show-more-text";
import { toggleHelpful } from "api/ActivityService";
import RatingStars from "./RatingStars";
import CollapsibleText from "./CollapsibleText";
import { Sentry } from "react-activity";

const ReviewCard = ({
  tag,
  review,
  onReviewClick,
  productId,
  fetchAllReviews,
  productData,
}) => {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const reviewId = review?._id;
  const userId = user ? user._id : "";
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [replyLoader, setReplyLoader] = useState(false);
  const [commentReviewLoader, setCommentReviewLoader] = useState(false);
  const [sendDisputeLoader, setSendDisputeLoader] = useState(false);
  const [page, setPage] = useState(1);
  const handleCloseModal1 = () => {
    setShowModal1(false);
    fetchAllReviews();
    setNewReply("");
    setPage(1);
  };
  // Comment
  const [replies, setReplies] = useState([]);
  const [newReply, setNewReply] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const loadMore = () => {
    if (page < totalPages) {
      setPage((prev) => prev + 1);
      setShowLoadMore(true);
      fetchData();
    }
  };
  const [isHelpful, setIsHelpful] = useState(review?.isHelpul || false);
  const [loading, setLoading] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const fetchData = async () => {
    try {
      if (!reviewId) return;

      const res = await getReviewAllReply({ page: page, limit: 10, reviewId });
      if (res.success) {
        setReplies((prev) => {
          const combined = [...prev, ...res.body.data];
          const unique = Array.from(
            new Map(combined.map((item) => [item._id, item])).values()
          );

          // Sort by createdAt descending
          unique.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

          return unique;
        });
        setTotal(res.body.total);
        setTotalPages(res.body.total_pages);
      }
      setReplyLoader(false);
      setShowLoadMore(false);
    } catch (error) {
      setReplyLoader(false);
      setShowLoadMore(false);
      console.error("Failed to fetch product details", error);
    }
  };
  useEffect(() => {
    if (showModal1) {
      setReplyLoader(true);
      fetchData();
    }
  }, [showModal1]);

  const repliesEndRef = useRef(null);

  useEffect(() => {
    if (repliesEndRef.current) {
      repliesEndRef.current.scrollIntoView({});
    }
  }, [replies]);

  const handleCloseModal = () => {
    setShowModal(false);
    setNewReply("");
  };
  const handleSendReply = async () => {
    try {
      if (newReply.trim() === "") {
        return toast.error("Please enter comment");
      }
      setCommentReviewLoader(true);
      const payload = {
        userId: userId,
        reviewId: review._id,
        review: newReply.trim(),
      };
      const res = await addCommentReview(payload);
      if (res.success === true && res.code === 200) {
        // toast.success(res.message);
        setNewReply("");
        fetchData();
      } else {
        toast.error(res.message);
      }
      setCommentReviewLoader(false);
    } catch (err) {
      setCommentReviewLoader(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleSendDispute = async () => {
    try {
      if (selectedReason === "") {
        return toast.error("Please a reason");
      }
      if (newReply.trim() === "") {
        return toast.error("Please enter description");
      }
      setSendDisputeLoader(true);
      const payload = {
        userId: userId,
        reviewId: review._id,
        productId: productId,
        reason: selectedReason,
        description: newReply.trim(),
      };
      const res = await addDisputeCommentReview(payload);
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        setShowModal(false);
        setNewReply("");
        setSelectedReason("");
      } else {
        toast.error(res.message);
      }
      setSendDisputeLoader(false);
    } catch (err) {
      setSendDisputeLoader(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleHelpfulClick = async () => {
    try {
      if (!userId) {
        return toast.error("Please login to mark review as helpful");
      }
      setLoading(true);
      const res = await toggleHelpful(reviewId); // Call your API
      if (res.success) {
        fetchAllReviews();
        setIsHelpful(res.body.isHelpul); // Set new status from response
      } else {
        toast.error("Something went wrong");
      }
    } catch (err) {
      toast.error("Failed to update");
    } finally {
      setLoading(false);
    }
  };
  console.log(
    'user && user?.role == "user" || !user',
    (user && user?.role == "user") || !user
  );
  const highlightedText = highlightTagInText(review?.review, tag);
  return (
    <div className="commentCard mb-3">
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-start mb-2 mb_Flex">
            <div style={{ flex: 1 }}>
              <Card.Title>
                <h5 style={{ fontSize: "1.1em",        wordBreak: "break-all", }}>"{review?.title}"</h5>
              </Card.Title>
              <div className="d-flex align-items-center mb-2">
                {/* {[...Array(Number(review?.overallRating))].map((_, i) => (
                  <FaStar key={i} color="gold" className="me-1" />
                ))} */}
                <RatingStars rating={review?.overallRating} />
                <span className=" total_review_text ms-2 ">
                  {moment(review?.createdAt).format("LL")}
                </span>
              </div>
            </div>
            {((user && user?.role == "user") || !user) && (
              <div className="d-flex gap-4 helpFull">
                <Link
                  onClick={handleHelpfulClick}
                  className="text-decoration-none d-flex align-items-center reveiw_comment_text"
                  style={{ color: isHelpful ? "#0071E3" : "#DC3545" }} // Blue if marked, red if not
                >
                  <Icon
                    icon={
                      isHelpful ? "iconamoon:like-fill" : "iconamoon:like-light"
                    }
                    fontSize={22}
                    className="me-2"
                    color={isHelpful ? "#0071E3" : "#DC3545"} // Filled blue icon when marked
                  />
                  {user && user?.role == "user" ? isHelpful ? "Marked as Helpful" : "Helpful?" : "Helpful?"}
                  {review?.helpfulCount ? `(${review?.helpfulCount})` : ""}
                </Link>

                <Link
                  onClick={(e) => {
                    if (!userId) {
                      e.preventDefault(); // ⛔ Stop navigation
                      toast.error("Please login to view comments");
                    }
                  }}
                  state={{
                    productName: productData?.name || "",
                    url: `/product-details/${productData?.slug}`,
                  }}
                  className="text-decoration-none blueColor d-flex align-items-center reveiw_comment_text"
                  to={`/review-comment/${review?._id}`}
                >
                  <Icon
                    icon="bx:comment-detail"
                    fontSize={20}
                    className="me-2"
                  />
                  Comments{" "}
                  {review?.totalReplies ? `(${review?.totalReplies})` : ""}
                </Link>
              </div>
            )}

            {user?.role == "vendor" && (
              <div className="d-flex gap-4 helpFull">
                <Link
                  style={{ flexShrink: 0 }}
                  to={`/review-comment/${review?._id}`}
                  state={{
                    productName: productData?.name || "",
                    url: `/product-details/${productData?.slug}`,
                  }}
                  className="text-decoration-none redColor d-flex align-items-center"
                >
                  <Icon
                    icon="flowbite:reply-outline"
                    fontSize={22}
                    className="me-2"
                  />{" "}
                  View Reply {review?.totalReplies ? `(${review?.totalReplies})` : ""} 
                </Link>
               {review?.productId?.userId === user?._id && <Link
                  onClick={() => setShowModal(true)}
                  className="text-decoration-none blueColor d-flex align-items-center "
                >
                  <Icon
                    icon="bx:comment-detail"
                    fontSize={20}
                    className="me-2"
                  />{" "}
                  Dispute
                </Link>}
              </div>
            )}
          </div>
          <Card.Text as="div">
            <CollapsibleText lines={5}>
            <div
    style={{
      whiteSpace: "pre-wrap",
      lineHeight: "1.6",
      marginBottom: "1rem",
      wordBreak: "break-all",
    }}
  >
    {highlightedText}
  </div>
            </CollapsibleText>
            {/* <ReactShowMoreText
              lines={2}
              more="See more"
              less="See less"
              anchorClass="see-more-link"
              expanded={false}
              width={0}
            >
              {highlightedText}
            </ReactShowMoreText> */}
          </Card.Text>
        </Card.Body>
      </Card>
      <div className="cardFooter">
        <div
          className="userBox"
          style={{ cursor: "pointer" }}
          onClick={() => {
            // if (!userId) {
            //   toast.error("Please login first");
            //   return;
            // }
            navigate(
              review?.userId?._id === userId
                ? `/my-profile`
                : `/public-profile/${review?.userId?._id}`
            );
          }}
        >
          <div className="userImage">
            <Image
              src={review?.userId?.profileUrl || IMAGES.User2_Img}
              className="userPos"
              alt=""
            />
            {review?.userId?.isProfileVerify !== "pending" && (
              <Image src={IMAGES.Verified} className="iconPos" alt="" />
            )}
          </div>
          <div className="flex-grow-1">
            <strong>{review?.userId?.displayName ? review?.userId?.displayName : `${review?.userId?.firstName} ${
              review?.userId?.lastName || ""
            }`}</strong>
            <p
              className="mb-0"
              style={{ fontSize: "0.9em", textTransform: "capitalize" }}
            >
              {[
                review?.userId?.title || "",
                review?.userId?.industry?.title || "",
              ]
                .filter(Boolean)
                .join(", ") +
                (review?.userId?.companySize !== undefined &&
                review?.userId?.companySize !== null &&
                review?.userId?.companySize !== ""
                  ? ` (${review.userId.companySize.title} emp.)`
                  : "")}
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 flex-wrap">
          {review?.verificationId?.status === "verified" && (
            <Badge bg="primary">Validated Reviewer</Badge>
          )}
          <Badge bg="primary" style={{ textTransform: "capitalize" }}>
            Review source: {review?.verificationId?.type.replace("_", " ")}
          </Badge>
          {/* <Badge bg="primary">Incentivized Review</Badge> */}
        </div>
      </div>

      <CommonModal
        title={"Dispute a Review"}
        para={"Describe your issue, and we’ll review it to find a solution."}
        body={
          <div className="mt-4">
            <Form.Group className="mb-3">
              <Form.Label className="d-block text-start">Reason</Form.Label>
              <Form.Select
                placeholder="Select Reason"
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
              >
                <option>Select Reason</option>
                <option>Inappropriate Content</option>
                <option>Spam or Misleading</option>
                <option>Factually Incorrect</option>
                <option>Competitor Review</option>
                <option>Violates Terms of Service</option>
                <option>Other</option>
              </Form.Select>
            </Form.Group>
            <TextInput
              labelText={"Description"}
              type="text"
              textarea="textarea"
              value={newReply}
              onChange={(e) => setNewReply(e.target.value)}
              rows={6}
              maxLength={1000}
              placeholder={"Explain dispute in detail..."}
              // errorMessage="Description is required"
            />

            <Button
              disabled={sendDisputeLoader}
              onClick={handleSendDispute}
              variant="info"
              className="w-100 mt-4 border-radius-100"
            >
              {sendDisputeLoader ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Submit"
              )}
            </Button>
          </div>
        }
        show={showModal}
        onClose={handleCloseModal}
      />

      {/* <CommonModal
        className="reviewModal"
        body={
          <div className="mt-4">
            <div className="review_Section mb-5">
              <div className="commentCard ">
                <Card>
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-start mb-2 mb_Flex">
                      <div style={{ flex: 1 }}>
                        <Card.Title>
                          <h5>"{review?.title}"</h5>
                        </Card.Title>
                        <div className="d-flex align-items-center mb-2">
                          {[...Array(Number(review?.overallRating))].map(
                            (_, i) => (
                              <FaStar key={i} color="gold" className="me-1" />
                            )
                          )}
                          <span className="ms-2 text-muted">
                            {moment(review?.createdAt).format("LL")}
                          </span>
                        </div>
                      </div>
                      {user?.role !== "vendor" && (
                        <div className="d-flex gap-4 helpFull">
                          <Link
                            onClick={handleHelpfulClick}
                            className="text-decoration-none d-flex align-items-center"
                            style={{ color: isHelpful ? "#0071E3" : "#DC3545" }} // Blue if marked, red if not
                          >
                            <Icon
                              icon={
                                isHelpful
                                  ? "iconamoon:like-fill"
                                  : "iconamoon:like-light"
                              }
                              fontSize={22}
                              className="me-2"
                              color={isHelpful ? "#0071E3" : "#DC3545"} // Filled blue icon when marked
                            />
                            {isHelpful ? "Marked as Helpful" : "Helpful?"}
                            {review?.helpfulCount
                              ? `(${review?.helpfulCount})`
                              : ""}
                          </Link>

                          <Link
                            className="text-decoration-none blueColor d-flex align-items-center"
                            onClick={() => onReviewClick(review?._id)}
                          >
                            <Icon
                              icon="bx:comment-detail"
                              fontSize={20}
                              className="me-2"
                            />{" "}
                            Add Comment{" "}
                            {review?.totalReplies
                              ? `(${review?.totalReplies})`
                              : ""}
                          </Link>
                        </div>
                      )}

                      <div className="d-flex gap-4 helpFull">
                        <Link
                          to={`/review-comment/${review?._id}`}
                          style={{ flexShrink: 0 }}
                          state={{
                            productName: productData?.name || "",
                            url: `/product-details/${productData?.slug}`,
                          }}
                   
                          // onClick={() => {
                          //   setShowModal1(true);
                          // }}
                          className="text-decoration-none redColor d-flex align-items-center"
                        >
                          <Icon
                            icon="flowbite:reply-outline"
                            fontSize={22}
                            className="me-2"
                          />{" "}
                          {review?.totalReplies
                            ? `${review?.totalReplies}`
                            : ""}{" "}
                          Reply
                        </Link>
                        <Link
                          onClick={() => {
                            setNewReply("");
                            setShowModal1(false);
                            setShowModal(true);
                          }}
                          className="text-decoration-none blueColor d-flex align-items-center "
                        >
                          <Icon
                            icon="bx:comment-detail"
                            fontSize={20}
                            className="me-2"
                          />{" "}
                          Dispute
                        </Link>
                      </div>
                    </div>
                    <Card.Text className="para">
                    
                      <CollapsibleText lines={4}>
                        <div
                          dangerouslySetInnerHTML={{ __html: review?.review }}
                          style={{
                            whiteSpace: "pre-wrap",
                            lineHeight: "1.6",
                            marginBottom: "1rem",
                          }}
                        />
                      </CollapsibleText>
                    </Card.Text>
                  </Card.Body>
                </Card>
                <div className="cardFooter">
                  <div className="userBox">
                    <div
                      className="userImage"
                      onClick={() => {
                        // if (!userId) {
                        //   toast.error("Please login first");
                        //   return;
                        // }
                        navigate(
                          review?.userId?._id === userId
                            ? `/my-profile`
                            : `/public-profile/${review?.userId?._id}`
                        );
                      }}
                    >
                      <Image
                        src={review?.userId?.profileUrl || IMAGES.User2_Img}
                        className="userPos"
                        alt=""
                      />
                      {review?.userId?.isProfileVerify !== "pending" && (
                        <Image
                          src={IMAGES.Verified}
                          className="iconPos"
                          alt=""
                        />
                      )}
                    </div>
                    <div className="flex-grow-1">
                      <strong>{`${review?.userId?.firstName} ${
                        review?.userId?.lastName || ""
                      }`}</strong>
                      <p className="mb-0" style={{ fontSize: "0.9em" }}>
                        {[
                          review?.userId?.title || "",
                          review?.userId?.industry || "",
                        ]
                          .filter(Boolean)
                          .join(", ") +
                          (review?.userId?.companySize !== undefined &&
                          review?.userId?.companySize !== null &&
                          review?.userId?.companySize !== ""
                            ? ` (${review?.userId?.companySize} emp.)`
                            : "")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="review_list_section">
              <h4>Replies {total > 0 && `(${total})`}</h4>

              <div className="replies-scroll-container">
                {replyLoader && !showLoadMore && (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "20vh" }}
                  >
                    <Sentry
                      color="#e91515"
                      size={40}
                      speed={1}
                      animating={true}
                    />
                  </div>
                )}
                <div ref={repliesEndRef}></div>

                {replies?.length > 0 &&
                  replies?.map((reply, index) => (
                    <div key={index} className="mb-3 review_list_section_card">
                      <div className="review_list_section_img">
                        <Image
                          src={
                            reply?.userId?.profileUrl
                              ? reply?.userId?.profileUrl
                              : IMAGES.User2_Img
                          }
                          roundedCircle
                          width={50}
                          height={50}
                          alt="User Avatar"
                        />
                        <div>
                          <h6 className="mb-0">
                            {`${reply?.userId?.firstName} ${
                              reply?.userId?.lastName || ""
                            }`}
                          </h6>
                          <small className="text-muted">
                            {moment(reply?.createdAt).fromNow()}
                          </small>
                        </div>
                      </div>
                      <div className="mt-2 para">
                        <CollapsibleText lines={5}>
                          <div
                            dangerouslySetInnerHTML={{ __html: reply?.review }}
                            style={{
                              whiteSpace: "pre-wrap",
                              lineHeight: "1.6",
                              marginBottom: "1rem",
                            }}
                          />
                        </CollapsibleText>
                      </div>
                    </div>
                  ))}

                {!replyLoader && replies?.length === 0 && (
                  <Col xs={12}>
                    <div className="text-center py-5">
                      <Image
                        src={IMAGES.emptyState}
                        alt=""
                        height="100px"
                        width="100px"
                        className="mb-4"
                        // className="imgUser"
                      />
                      <p className="text-center text-muted">
                        No replies found.
                      </p>
                    </div>
                  </Col>
                )}
                {replies?.length > 0 && page < totalPages && !replyLoader && (
                  <Col md={12}>
                    <div className="centerbtn">
                      <Button
                        variant="outline-primary"
                        className="iconFlex border-radius-100"
                        onClick={loadMore}
                        disabled={showLoadMore}
                      >
                        {showLoadMore ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Load More"
                        )}
                      </Button>
                    </div>
                  </Col>
                )}
              </div>

              <div className="d-flex align-items-center justify-content-center">
                <TextInput
                  type="text"
                  // textarea="textarea"
                  // rows={6}
                  value={newReply}
                  className="mb0Textinput"
                  style={{ marginBottom: "0 !important" }}
                  onChange={(e) => {
                    setNewReply(e.target.value);
                  }}
                  maxLength={4000}
                  placeholder={"Type here..."}
                />
                <Button
                  disabled={commentReviewLoader}
                  variant="info"
                  className="ms-2 border-radius-100 px-5"
                  onClick={handleSendReply}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSendReply();
                    }
                  }}
                >
                  {commentReviewLoader ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Send"
                  )}
                </Button>
              </div>
            </div>
          </div>
        }
        show={showModal1}
        onClose={() => handleCloseModal1()}
      /> */}
    </div>
  );
};

// const ratingData = {
//   average: 4.7,
//   totalReviews: 2306,
//   ratings: [
//     { stars: 5, count: 987 },
//     { stars: 4, count: 786 },
//     { stars: 3, count: 655 },
//     { stars: 2, count: 235 },
//     { stars: 1, count: 1 },
//   ],
// };

// const popularMentions = [
//   "All Reviews",
//   "Automations",
//   "Team",
//   "Team Members",
//   "Time Tracking",
//   "Communication",
//   "Difference",
//   "Features",
//   "Organization",
//   "Platform",
//   "Project Board",
//   "Projects",
//   "Task Lists",
//   "Task",
//   "Time Zones",
//   "Track",
// ];

const ReviewsComponent = ({ productData, productId, userId }) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState("");
  const [comment, setComment] = useState("");
  const [star, setStar] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const limit = 10;
  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 500);
  const [mentions, setMentions] = useState([]);
  const [commentLoader, setCommentLoader] = useState(false);
  const [selectedSoftware, setSelectedSoftware] = useState({
    label: "All Reviews",
    value: "all",
  });
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const handleAddComment = async () => {
    setCommentLoader(true);
    try {
      if (comment === "") {
        return toast.error("Please enter comment");
      }
      if (show === "") {
        return;
      }
      const payload = {
        userId: userId,
        reviewId: show,
        review: comment,
      };
      const res = await addCommentReview(payload);
      if (res.success === true && res.code === 200) {
        // toast.success(res.message);
        fetchData();
        setShow("");
        setComment("");
      } else {
        toast.error(res.message);
      }
      setCommentLoader(false);
    } catch (err) {
      setCommentLoader(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  const fetchData = async (currentPage = page) => {
    try {
      if (!productId) return;
      const tag =
        selectedSoftware.value !== "all" ? selectedSoftware.value : "";

      const res = await fetchProductReviews({
        search: debouncedSearch,
        productId,
        tag,
        star,
        limit,
        page: currentPage,
        userId,
      });
      if (res.success) {
        if (tag) {
          setSearchText("");
        }
        // setData(res.body.data);
        setData((prev) =>
          currentPage === 1 ? res.body.data : [...prev, ...res.body.data]
        );
        setTotalPages(res.body.total_pages);
      }

      setLoading(false);
      setLoadMoreLoading(false);
    } catch (error) {
      setLoading(false);
      setLoadMoreLoading(false);
      console.error("Failed to fetch product details", error);
    }
  };

  const fetchMentions = async () => {
    try {
      const res = await reviewPopularMentions({
        productId,
        page: 1,
        limit: 10,
      });
      if (res.success) {
        // setProducts(res.body.data); // set current page data onl
        const optimiseData =
          res.body?.map((v) => ({ label: v, value: v })) || [];
        setMentions(optimiseData);
      }
    } catch (err) {
      console.error("Failed to fetch pouplar mentions", err);
    }
  };

  useEffect(() => {
    setLoading(true);

    setPage(1);
    fetchData();
  }, [productId, selectedSoftware, debouncedSearch, star]);
  useEffect(() => {
    fetchMentions();
  }, [productId]);
  // console.log("tag", selectedSoftware);
  const loadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchData(nextPage);
    setLoadMoreLoading(true);
  };
  // const loadMore = () => {
  //   if (page < totalPages) {
  //     setPage((prev) => prev + 1);
  //   }
  // };
  return (
    <div className="review_Section">
      <Row className="mb-3">
        <Col md={12} lg={7}>
          <div className="review_rewFlex">
            <div className="fFull1">
              <h4>Reviews</h4>
              <div className="count_flex d-flex flex-column align-items-center gap-2">
              <h2>{productData?.avgRating?.toFixed(1)}</h2>
              <div>
             <RatingStars rating={productData?.avgRating} />
              <span className="text-muted d-block mt-2 font12">
                ({productData?.totalReviews} Reviews)
              </span>
             </div>
              </div>
              {/* {[...Array(5)].map((_, i) => {
                const rating = productData?.avgRating || 0;
                const full = i + 1 <= Math.floor(rating);
                const half = i + 1 > Math.floor(rating) && i < rating;

                return full ? (
                  <FaStar key={i} color="gold" fontSize={20} className="me-1" />
                ) : half ? (
                  <FaStarHalfAlt
                    key={i}
                    color="gold"
                    fontSize={20}
                    className="me-1"
                  />
                ) : (
                  <FaRegStar
                    key={i}
                    color="lightgray"
                    fontSize={20}
                    className="me-1"
                  />
                );
              })} */}
             
            </div>
            <div className="fFull">
              {productData?.ratingData?.ratings?.map((rating, index) => {
                return (
                  <div
                    key={index}
                    className="d-flex align-items-center rating-group cursor-pointer"
                    onClick={() => setStar(rating?.stars)}
                  >
                    <span
                      className={`me-2 rating-stars cursor-pointer`}
                      style={{
                        textDecoration: star === rating?.stars && "underline",
                      }}
                    >
                      {rating?.stars} stars
                    </span>
                    <ProgressBar
                      onClick={() => setStar(rating?.stars)}
                      now={(rating?.count / productData?.totalReviews) * 100}
                      className="flex-grow-1 me-2 cursor-pointer"
                      style={{ height: "6px" }}
                      variant="warning"
                    />
                    <span
                      className={`rating-count  cursor-pointer`}
                      style={{
                        textDecoration: star === rating?.stars && "underline",
                      }}
                    >
                      {rating?.count}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </Col>

        <Col md={12} lg={5}>
          <div className="searchMentions">
            <div className="searchInput">
              <Image src={IMAGES.Search_Normal} alt="search" />
              <Form.Control
                placeholder="Search reviews..."
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                  setSelectedSoftware({ label: "All Reviews", value: "all" });
                }}
              />
            </div>
            <h6>Popular Mentions</h6>
            <div className="d-flex flex-wrap gap-2 ">
              {[
                {
                  label: "All Reviews",
                  value: "all",
                },
              ]
                .concat(mentions)
                ?.map((mention, index) => (
                  <Badge
                    key={index}
                    pill
                    bg={
                      mention.value === selectedSoftware.value
                        ? "danger"
                        : "white"
                    }
                    text={
                      mention.value === selectedSoftware.value
                        ? "white"
                        : "dark"
                    }
                    className="p-2"
                    onClick={() => setSelectedSoftware(mention)}
                    style={{ cursor: "pointer", textTransform: "capitalize" }}
                  >
                    {mention.label}
                  </Badge>
                ))}
            </div>
          </div>
        </Col>
      </Row>

      {loading && !loadMoreLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "40vh" }}
        >
          <Sentry color="#e91515" size={40} speed={1} animating={true} />
        </div>
      ) : (
        data?.length > 0 &&
        data?.map((review, index) => (
          <ReviewCard
            productData={productData}
            tag={selectedSoftware.value === "all" ? "" : selectedSoftware.value}
            key={index}
            review={review}
            productId={productId}
            fetchAllReviews={() => fetchData()}
            onReviewClick={(data) => setShow(data)}
          />
        ))
      )}

      {!loading && data?.length > 0 && page < totalPages && (
        <div className="text-center mt-3 d-flex justify-content-center">
          <Button
            className="added_width1 mb-4"
            variant="outline-primary"
            onClick={loadMore}
            disabled={loadMoreLoading}
            style={{
              width: "351px",
              borderRadius: "50px",
              borderColor: "#0071E3",
              color: "#0071E3",
              
            }}
          >
            {loadMoreLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "More Reviews"
            )}
          </Button>
        </div>
      )}

      {!loading && data?.length === 0 && (
        <Col xs={12}>
          <div className="text-center py-5">
            <Image
              src={IMAGES.emptyState}
              alt=""
              height="200px"
              width="200px"
              className="mb-4"
              // className="imgUser"
            />
            <p className="text-center text-muted">No reviews found.</p>
          </div>
        </Col>
      )}

      <CommonModal
        image
        paraStyle={{ maxWidth: "600px", marginTop: "10px" }}
        title="Comment on Review"
        para="Share your thoughts or ask questions about this review to join the conversation and provide additional insights."
        body={
          <>
            <TextInput
              labelText={"Comment"}
              type="email"
              textarea="textarea"
              rows={6}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder={"Write Your Comment..."}
            />
            <Button
              disabled={commentLoader}
              variant="info"
              onClick={handleAddComment}
              className="w-100 border-radius-100 mt-3"
            >
              {commentLoader ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Continue"
              )}
            </Button>
          </>
        }
        show={show !== ""}
        onClose={() => setShow("")}
      />
    </div>
  );
};

export default ReviewsComponent;
